<ul class="nav nav-tabs mb-1">
  <li class="nav-item">
    <a
      class="nav-link"
      href="javascript:void(0)"
      [class.active]="tab === 'cibles'"
      (click)="setTab('cibles')"
    >
      Magasins cibles (min / max)
    </a>
  </li>
  <li class="nav-item">
    <a
      class="nav-link"
      href="javascript:void(0)"
      [class.active]="tab === 'priorites'"
      (click)="setTab('priorites')"
    >
      Priorité magasins cibles
    </a>
  </li>
</ul>

<p class="text-muted small mb-1" *ngIf="tab === 'cibles'">
  Seuils min/max par article pour chaque <strong>magasin cible</strong>.
  Les entrepôts marqués « Réassort » sont des <strong>sources de stock</strong> (départ) : ils n’ont pas de min/max ici.
</p>
<p class="text-muted small mb-1" *ngIf="tab === 'priorites'">
  Ordre d’alimentation des <strong>magasins cibles</strong> (1 = servi en premier).
  Les entrepôts source réassort (<code>is_reassort</code>) ne sont pas dans cette liste : ils fournissent uniquement le stock.
</p>

<app-logiciel-caisse-list-toolbar
  [(searchTerm)]="searchTerm"
  (searchTermChange)="applySearch()"
  [primaryLabel]="tab === 'priorites' ? (savingPriorite ? 'Enregistrement…' : 'Enregistrer l’ordre') : ''"
  (primaryClick)="savePriorites()"
></app-logiciel-caisse-list-toolbar>

<div class="table-full-width" *ngIf="tab === 'cibles'">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Code</th>
          <th>Libellé</th>
          <th>Ville</th>
          <th>Priorité</th>
          <th style="width: 140px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="5">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredCibles" [hidden]="loading">
          <td>{{ rowCode(row) }}</td>
          <td>{{ rowLibelle(row) }}</td>
          <td>{{ row.VILLE || '—' }}</td>
          <td>{{ row['PRIORITÉ'] || '—' }}</td>
          <td>
            <button type="button" class="btn btn-sm btn-primary" (click)="openConfig(row)">
              Config min/max
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredCibles.length === 0" class="lc-empty-row">
          <td colspan="5">Aucun magasin cible. Créez des entrepôts sans flag Réassort / Globale.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="table-full-width" *ngIf="tab === 'priorites'">
  <div class="table-responsive lc-table-scroll">
    <table class="table table-hover pos-ticket-table">
      <thead class="custom-header">
        <tr>
          <th>Priorité</th>
          <th>Code</th>
          <th>Libellé</th>
          <th style="width: 160px">Ordre</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading" class="lc-loading-row">
          <td colspan="4">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Chargement…
          </td>
        </tr>
        <tr *ngFor="let row of filteredCibles" [hidden]="loading">
          <td>{{ cibles.indexOf(row) + 1 }}</td>
          <td>{{ rowCode(row) }}</td>
          <td>{{ rowLibelle(row) }}</td>
          <td>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary mr-50"
              (click)="moveUp(cibles.indexOf(row))"
              [disabled]="!!searchTerm.trim()"
            >
              ↑
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="moveDown(cibles.indexOf(row))"
              [disabled]="!!searchTerm.trim()"
            >
              ↓
            </button>
          </td>
        </tr>
        <tr *ngIf="!loading && filteredCibles.length === 0" class="lc-empty-row">
          <td colspan="4">Aucun magasin cible à prioriser.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
